import { decimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

import { originalSourceSchema } from '../enums';
import {
  partEngineeringStatusSchema,
  partEngineeringTypeSchema,
} from '../part-engineering/enums';
import { prismaRunRateTypeSchema, prismaScrapYieldTypeSchema } from './enums';

export const columns = {
  id: z.string(),
  engType: partEngineeringTypeSchema,
  engStatus: partEngineeringStatusSchema,
  baseId: z.string(),
  lotId: z.string(),
  splitId: z.string(),
  subId: z.string(),
  sequenceNum: z.number(),
  resourceId: z.string(),
  runRate: decimal.nullable(),
  runRateType: prismaRunRateTypeSchema,
  qtyPerLineQty: decimal.nullable(),
  runHrsPerLineQty: decimal.nullable(),
  qtyPerRunHr: decimal.nullable(),
  estLoadSizeQty: decimal.nullable(),
  estStartQty: decimal.nullable(),
  estEndQty: decimal.nullable(),
  actCompletedQty: decimal.nullable(),
  estSetupHrs: decimal.nullable(),
  estRunHrs: decimal.nullable(),
  actSetupHrs: decimal.nullable(),
  actRunHrs: decimal.nullable(),
  estLabSetupCostPerHr: decimal.nullable(),
  estLabRunCostPerHr: decimal.nullable(),
  estRunCostPerUnit: decimal.nullable(),
  estBurRunCostPerHr: decimal.nullable(),
  estBurSetupCostPerHr: decimal.nullable(),
  estBurRunCostPerUnit: decimal.nullable(),
  estBurPctSetup: decimal.nullable(),
  estBurPctRun: decimal.nullable(),
  estBurPerOperation: decimal.nullable(),
  actLabSetupCostPerHr: decimal.nullable(),
  actLabRunCostPerHr: decimal.nullable(),
  actBurSetupCostPerHr: decimal.nullable(),
  actBurRunCostPerHr: decimal.nullable(),
  estAtlLabTotal: decimal.nullable(),
  estAtlBurTotal: decimal.nullable(),
  estAtlSrvTotal: decimal.nullable(),
  estReqMatTotal: decimal.nullable(),
  estReqLabTotal: decimal.nullable(),
  estReqBurTotal: decimal.nullable(),
  estReqSrvTotal: decimal.nullable(),
  actAtlLabTotal: decimal.nullable(),
  actAtlBurTotal: decimal.nullable(),
  actAtlSrvTotal: decimal.nullable(),
  actReqMatTotal: decimal.nullable(),
  actReqLabTotal: decimal.nullable(),
  actReqBurTotal: decimal.nullable(),
  actReqSrvTotal: decimal.nullable(),
  serviceId: z.string().nullable(),
  estSrvBaseCharge: decimal.nullable(),
  estSrvMinCharge: decimal.nullable(),
  scrapFixedUnits: decimal.nullable(),
  scrapYieldType: prismaScrapYieldTypeSchema,
  scrapYieldPercent: decimal.nullable(),
  servicePartId: z.string().nullable(),
  originalSource: originalSourceSchema,
  siteId: z.string(),
  quotingConfigId: z.string().nullable(),
  quotingConfigHistoryIds: z.array(z.string()),
  createdById: z.string().nullable(),
  createdByService: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
};
